<template>
  <div>
    <v-subheader>Home</v-subheader>
  </div>
</template>
<script>
export default {
  name: 'DashboardHome'
}
</script>